import React, { Component, Fragment } from 'react';
import FieldHeader from './utility/FieldHeader';
import PropTypes from 'prop-types';
import { isEmpty } from '../utils/obj-utils';

class FormMultipleInterests extends Component {
    constructor(props) {
        super(props);
        // TODO: fix venues update;
        const { validState, defaultValue } = props;
        this.initialState = { venues: [], isValid: true, errorMessage: '' };

        if (validState) {
            this.initialState.isValid = validState.isValid;
            this.initialState.errorMessage = validState.errorMessage;
        }

        if (!isEmpty(defaultValue)) {
            this.initialState.venues = defaultValue;
        }

        this.state = this.initialState;

        this.displayVenues = this.displayVenues.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeCallback = this.handleChangeCallback.bind(this);
        this.displayHeader = this.displayHeader.bind(this);
    }

    displayHeader() {
        const { name,
            headerTitle,
            headerText,
            isHidden,
            interestsData } = this.props;

        if (isHidden || interestsData.choices.length == 0)
            return;

        return <FieldHeader style={{ display: isHidden ? 'none' : 'block' }}
            fieldName={name}
            headerTitle={headerTitle}
            headerText={headerText}
            textClassName={'text-info'}>
        </FieldHeader>;
    }

    displayVenues() {
        const { interestsData, defaultValue } = this.props;

        return interestsData.choices.map((venue) => {
            let isSelected = false;
            if (!isEmpty(defaultValue)) {
                const defaultValuesUpper = defaultValue.map(item => item.toUpperCase()); 
                isSelected = defaultValuesUpper.includes(venue.id.toUpperCase());
            }

            return (<div
                key={venue.id}
                className='form-checkbox form-checkbox-panel__container'
            >
                <label className="form-switch">
                    <input
                        type='checkbox'
                        className='form-checkbox__checkbox visually-hidden'
                        name={venue.id}
                        id={venue.id}
                        onChange={this.handleChange}
                        defaultChecked={isSelected}
                    /><i></i>{venue.label}
                </label>
            </div >);
        });
    }

    handleChange(event) {
        const target = event.target;
        const isChecked = target.checked;
        const name = target.name;

        const venues = this.state.venues.map(item => item.toUpperCase());

        const indexOfVenue = venues.indexOf(name.toUpperCase());

        this.setState((state) => {
            const venues = isChecked ?
                [...state.venues, name] :
                state.venues.filter((item, j) => indexOfVenue !== j);

            return {
                venues
            };
        }, this.handleChangeCallback);
    }

    handleChangeCallback() {
        const { onChange, name } = this.props;
        onChange({
            target: {
                name,
                value: this.state.venues
            }
        });
    }

    render() {
        const {
            interestsData,
            isHidden,
            validState,
            formRef
        } = this.props;
        const { isValid, errorMessage } = validState || this.state;

        return (
            <Fragment>
                {this.displayHeader()}
                <div ref={formRef} className='form-field auto-mt-xs'>
                    { interestsData.choices.length == 0 ? "" : 
                        <div className='form-checkbox-panel'>
                            <h5 className='form-checkbox-panel__title'>
                                {interestsData.label}
                            </h5>
                            {this.displayVenues()}
                            {!isValid ? <ul className="form-field__error-list filled">
                                <li className="form-field__error-item">{errorMessage}</li>
                            </ul> : null}
                        </div>
                    }
                </div>
            </Fragment>
        );
    }
}

FormMultipleInterests.propTypes = {
    formRef: PropTypes.object,
    interestsData: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    defaultValue: PropTypes.array,
    onChange: PropTypes.func,
    validState: PropTypes.object
};

export default FormMultipleInterests;
